import * as React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";

export default function ThemeToggleButton() {
	const [alignment, setAlignment] = React.useState("light");

	const handleChange = (event, newAlignment) => {
		setAlignment(newAlignment);
	};

	return (
		<ToggleButtonGroup
			size="small"
			value={alignment}
			exclusive
			onChange={handleChange}
			aria-label="Theme mode"
		>
			<ToggleButton
				value="light"
				sx={{
					borderRadius: 12,
					// backgroundColor: 'primary.dark',
					// color: "#000",
					"&.Mui-selected": {
						// backgroundColor: "primary.main",
						// color: "#fff",
					},
					"&:hover": {
						// backgroundColor: '#222',
					},
				}}
			>
				<LightModeIcon></LightModeIcon>
			</ToggleButton>
			<ToggleButton
				value="dark"
				sx={{
					borderRadius: 12,
					"&.Mui-selected": {},
					"&:hover": {},
				}}
			>
				<DarkModeIcon></DarkModeIcon>
			</ToggleButton>
		</ToggleButtonGroup>
	);
}
